var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrFrinline = function SvgFrFrinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr-fr_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr-fr_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01209F",
    d: "M5.212 17.53h-6.633a.947.947 0 0 1-.947-.948V1.422c0-.523.424-.947.947-.947h6.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4234",
    d: "M20.373 16.582a.947.947 0 0 1-.948.947h-6.632V.475h6.632c.524 0 .948.424.948.947z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12.79.475H5.21v17.054h7.58z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fr-fr_inline_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.003,
    height: 18.003,
    fill: "#fff",
    rx: 9.001
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fr-fr_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2.368-2.368H20.37V20.37H-2.37z"
  })))));
};
export default SvgFrFrinline;